import { EmployeeCreate } from './EmployeeCreate';
import { EmployeeEdit } from './EmployeeEdit';
import { EmployeeList } from './EmployeeList';

export default {
    list: EmployeeList,
    create: EmployeeCreate,
    edit: EmployeeEdit
};